export default {
  "kpi": {
    "config": {
      "changed": false,
      "title": "KPI",
      "navSection": "kpi",
      "icon": "kpi",
      "image": "kpi.png"
    },
    "items": {
      "indicator": {
        "indicatorDisplayUnits": "Auto",
        "indicatorPrecision": 1,
        "showIcon": true,
        "iconSize": 15,
        "horizontalAlignment": "left",
        "verticalAlignment": "top"
      },
      "trendline": {
        "show": true,
        "transparency": 50
      },
      "goals": {
        "showGoal": true,
        "showDistance": true,
        "goalText": "",
        "goalFontColor": "#252423",
        "goalFontFamily": "Segoe UI",
        "fontSize": 12,
        "distanceLabel": "Value, percent",
        "labelPrecision": 2,
        "distanceFontColor": "#252423",
        "distanceFontFamily": "Segoe UI",
        "titleFontSize": 12
      },
      "status": {
        "direction": "Negative",
        "goodColor": "#252423",
        "neutralColor": "#FFB8DD",
        "badColor": "#018866"
      },
      "lastDate": {
        "show": false,
        "lastDateFontColor": "#252423",
        "lastDateFontFamily": "Segoe UI",
        "fontSize": 9
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "pivotTable": {
    "config": {
      "changed": true,
      "title": "Matrix",
      "navSection": "kpi",
      "icon": "pivotTable",
      "image": "pivotTable.png"
    },
    "items": {
      "stylePreset": {
        "name": "None"
      },
      "grid": {
        "gridVertical": false,
        "gridVerticalColor": "#E5E5E5",
        "gridVerticalWeight": 1,
        "gridHorizontal": true,
        "gridHorizontalColor": "#E5E5E5",
        "gridHorizontalWeight": 1,
        "rowPadding": 2,
        "outlineColor": "rgba(17,141,255,0)",
        "outlineWeight": 1,
        "textSize": 10,
        "imageHeight": 110
      },
      "columnHeaders": {
        "titleAlignment": "Auto",
        "urlIcon": false,
        "fontColor": "#ffffff",
        "backColor": "#5e78e5",
        "outline": "TopOnly",
        "autoSizeColumnWidth": true,
        "fontFamily": "Segoe UI",
        "fontSize": 8,
        "alignment": "Auto",
        "wordWrap": true
      },
      "rowHeaders": {
        "fontColor": "#020f47",
        "backColor": "rgba(255,255,255,0)",
        "outline": "RightOnly",
        "stepped": true,
        "steppedLayoutIndentation": 10,
        "urlIcon": false,
        "wordWrap": true,
        "fontFamily": "Segoe UI",
        "fontSize": 8,
        "alignment": "Auto",
        "showExpandCollapseButtons": true,
        "expandCollapseButtonsColor": "#FFFFFF",
        "expandCollapseButtonsSize": 8
      },
      "values": {
        "bandedRowHeaders": false,
        "valuesOnRow": false,
        "fontColorPrimary": "#020f47",
        "backColorPrimary": "rgba(255,255,255,0)",
        "fontColorSecondary": "#020f47",
        "backColorSecondary": "rgba(255,255,255,0)",
        "outline": "None",
        "urlIcon": false,
        "wordWrap": true,
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "subTotal": {
        "rowSubtotals": true,
        "columnSubtotals": false,
        "fontColor": "#020f47",
        "fontFamily": "Segoe UI",
        "backColor": "#FFFFFF",
        "fontSize": 8,
        "applyToHeaders": true,
        "rowSubtotalsPosition": "Bottom",
        "perRowLevel": false,
        "perColumnLevel": false
      },
      "total": {
        "applyToHeaders": true,
        "fontColor": "#020f47",
        "fontFamily": "Segoe UI",
        "backColor": "rgba(2,15,71,0)",
        "fontSize": 8
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": true,
        "color": "#cccccc",
        "radius": 10
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Default",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 0,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 0,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "slicer": {
    "config": {
      "changed": true,
      "title": "Slicer",
      "navSection": "kpi",
      "icon": "slicer",
      "image": "slicer.png"
    },
    "items": {
      "general": {
        "responsive": true,
        "outlineColor": "#605E5C",
        "outlineWeight": 1,
        "orientation": "vertical"
      },
      "selection": {
        "selectAllCheckboxEnabled": true,
        "singleSelect": true,
        "strictSingleSelect": false
      },
      "header": {
        "show": false,
        "fontColor": "#020f47",
        "background": "rgba(255,255,255,0)",
        "outline": "None",
        "textSize": 8,
        "fontFamily": "Segoe UI"
      },
      "items": {
        "fontColor": "#020f47",
        "background": "#fbfbfb",
        "outline": "None",
        "textSize": 8,
        "fontFamily": "Segoe UI"
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 14,
        "fontFamily": "DIN"
      },
      "background": {
        "show": true,
        "color": "#fbfbfb",
        "transparency": 0
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 20,
        "foreground": "#4d4946",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "tableEx": {
    "config": {
      "changed": true,
      "title": "Table",
      "navSection": "kpi",
      "icon": "tableEx",
      "image": "tableEx.png"
    },
    "items": {
      "stylePreset": {
        "name": "None"
      },
      "grid": {
        "gridVertical": false,
        "gridVerticalColor": "#E5E5E5",
        "gridVerticalWeight": 1,
        "gridHorizontal": true,
        "gridHorizontalColor": "#E5E5E5",
        "gridHorizontalWeight": 1,
        "rowPadding": 2,
        "outlineColor": "rgba(17,141,255,0)",
        "outlineWeight": 1,
        "textSize": 10,
        "imageHeight": 110
      },
      "columnHeaders": {
        "fontColor": "#ffffff",
        "backColor": "#5e78e5",
        "outline": "TopOnly",
        "autoSizeColumnWidth": true,
        "fontFamily": "Segoe UI",
        "fontSize": 8,
        "alignment": "Auto",
        "wordWrap": false
      },
      "values": {
        "fontColorPrimary": "#020f47",
        "backColorPrimary": "rgba(255,255,255,0)",
        "fontColorSecondary": "#020f47",
        "backColorSecondary": "rgba(238,237,237,0)",
        "outline": "None",
        "urlIcon": false,
        "wordWrap": false,
        "fontFamily": "Segoe UI",
        "fontSize": 8
      },
      "total": {
        "totals": true,
        "outline": "BottomOnly",
        "fontColor": "#020f47",
        "fontFamily": "Segoe UI",
        "backColor": "rgba(255,255,255,0)",
        "fontSize": 8
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "rgba(255,255,255,0)",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#cccccc",
        "radius": 10
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "scriptVisual": {
    "config": {
      "changed": false,
      "title": "R script visual",
      "navSection": "kpi",
      "icon": "scriptVisual",
      "image": "scriptVisual.png"
    },
    "items": {
      "title": {
        "show": true,
        "text": "4444",
        "titleWrap": false,
        "fontColor": "#937454",
        "background": "#896868",
        "alignment": "center",
        "fontSize": 15,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 4
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#874343",
        "radius": 0
      },
      "dropShadow": {
        "show": true,
        "color": "#5a4937",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "pythonVisual": {
    "config": {
      "changed": false,
      "title": "Python visual",
      "navSection": "kpi",
      "icon": "pythonVisual",
      "image": "pythonVisual.png"
    },
    "items": {
      "title": {
        "show": true,
        "text": "4444",
        "titleWrap": false,
        "fontColor": "#937454",
        "background": "#896868",
        "alignment": "center",
        "fontSize": 15,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 4
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#874343",
        "radius": 1
      },
      "dropShadow": {
        "show": true,
        "color": "#5a4937",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  }
}